export interface YtdFile {
  name: string;
  sizeMb: number;
}

export interface Resource {
  name: string;
  relativePath: string;
  fileCount: number;
  sizeMb: number;
  hasOversized: boolean;
  oversizedFiles: YtdFile[];
  ytdFiles: YtdFile[];
}

export interface OversizedLogMatch {
  name: string;
  relativePath: string;
  ytdCount: number;
  oversizedFiles: YtdFile[];
}

export interface JobState {
  active: boolean;
  progress: number;
  status: 'idle' | 'starting' | 'running' | 'success' | 'failed' | 'cancelled';
  filesCount: number;
  filesOptimized: number;
  savedSize: number;
  estimatedTimeRemaining: number;
  error: string | null;
  logs: string[];
  currentFile: string | null;
}

export const INITIAL_JOB_STATE: JobState = {
  active: false,
  progress: 0,
  status: 'idle',
  filesCount: 0,
  filesOptimized: 0,
  savedSize: 0,
  estimatedTimeRemaining: 0,
  error: null,
  logs: [],
  currentFile: null,
};

export interface OptimizeSettings {
  downsize: boolean;
  format: boolean;
  onlyOversized: boolean;
  sizeThreshold: string;
  backupRoot: string;
}

export const DEFAULT_SETTINGS: OptimizeSettings = {
  downsize: true,
  format: true,
  onlyOversized: false,
  sizeThreshold: '2048',
  backupRoot: 'C:\\Users\\Administrator\\Desktop\\SCLABS-TEXTURE-BACKUP',
};
